// Firmy, provozovny, pracoviště a odpovědné osoby — jen přehled.
// Fáze 2 ekosystému (rozhodnutí uživatele 2026-11-02): kmenová data spravuje
// jen administrátor v portálu BOZP-SOFTWARE (/firmy/), portál je posílá do
// tabulek Auditu (audit.nastavit_kmen). Tady se jen zobrazují (+ QR štítky).
import { ICONS, currentCompany, esc, groupWorkplacesByBranch, isMyCorrective, myRole, normalizeSearchText, realRole, sortedBranches, sortedCompanies, sortedWorkplaces, state, workplaceCountForCompany, workplaceLabel, workplaceParent, workplaceChildren } from '../core/state.js';
import { paginateList, paginationControlsHtml } from '../core/pagination.js';
import { settingsHeadHtml, settingsTabsHtml } from '../core/ui-kit.js';
import { companyAccessSummary, companyWhoSeesHtml } from '../core/access.js';
import { portalUrl } from '../core/licence.js';
import { usersWithCompanyAccess } from './schedule.js';
import { workplaceResponsibleId } from '../../supabase/functions/_shared/calc.js';
import { render } from '../main-render.js';

// Odkaz do portálu (Firmy a pracoviště), u konkrétní firmy rovnou na ni.
function portalPlacesUrl(companyId){
  return portalUrl() + '/firmy/' + (companyId ? '?firma=' + encodeURIComponent(companyId) : '');
}
App.openPortalPlaces = function(companyId){ location.href = portalPlacesUrl(companyId); };

// ================= FIRMY (právní subjekty) =================
function companyDetailHtml(id){
  var c = state.companies.get(id);
  if(!c) return '<div class="empty">'+ICONS.empty+'<p>Firma neexistuje.</p></div>';
  var html = '<div class="card"><div style="display:flex;align-items:center;gap:14px">' +
    (c.logoUrl ? '<img src="'+esc(c.logoUrl)+'" alt="" style="height:'+(c.logoHeight||32)+'px;width:auto;max-width:160px;object-fit:contain"/>' : '') +
    '<div style="min-width:0"><div style="font-weight:700;font-size:var(--fs-lg);overflow-wrap:anywhere">'+esc(c.name||'(bez názvu)')+'</div>' +
    (c.ico ? '<div class="muted" style="font-size:var(--fs-sm);margin-top:2px">IČO '+esc(c.ico)+'</div>' : '') +
    (c.address ? '<div class="muted" style="font-size:var(--fs-sm);margin-top:2px">'+esc(c.address)+'</div>' : '') +
    '</div></div></div>';
  return html + companyWhoSeesHtml(id);
}
function companiesSectionHtml(){
  var isAdmin = myRole()==='administrator';
  if(state.editCompanyId) return companyDetailHtml(state.editCompanyId);
  var html = '';
  var list = sortedCompanies();
  if(list.length===0){
    html += '<div class="empty">'+ICONS.empty+'<p>Zatím žádný právní subjekt.</p></div>';
  } else {
    var cPage = paginateList(list, 'companiesPage');
    html += '<div class="card" style="margin-top:12px">';
    cPage.items.forEach(function(e){
      var id=e[0], c=e[1];
      var active = id===state.currentCompanyId;
      var wpCount = workplaceCountForCompany(id);
      html += '<div class="list-item">' +
        '<div style="min-width:0;display:flex;align-items:center;gap:8px">' +
          (c.logoUrl ? '<img src="'+esc(c.logoUrl)+'" style="width:28px;height:28px;border-radius:6px;object-fit:contain;background:var(--surface-2);flex-shrink:0"/>' : '') +
          '<div style="min-width:0"><div style="font-weight:600;font-size:var(--fs-md);overflow-wrap:anywhere">'+esc(c.name||'(bez názvu)')+
          (active?' <span class="muted" style="font-weight:500;font-size:var(--fs-sm)">· aktivní</span>':'')+'</div>' +
          '<div class="muted" style="font-size:var(--fs-sm);margin-top:2px">'+[c.ico ? 'IČO '+esc(c.ico) : '', wpCount+' prac.'].filter(Boolean).join(' · ')+'</div>' +
          (isAdmin ? '<div class="muted" style="font-size:var(--fs-sm);margin-top:2px">'+companyAccessSummary(id)+'</div>' : '') + '</div></div>' +
        '<div style="display:flex;gap:2px;flex-shrink:0;align-items:center">' +
          (!active ? '<button class="btn btn-sm btn-ghost" onclick="App.switchCompany(\''+id+'\')">Aktivovat</button>' : '') +
          '<button class="icon-btn" title="Podrobnosti" aria-label="Podrobnosti" onclick="App.editCompany(\''+id+'\')">'+ICONS.chev+'</button>' +
        '</div></div>';
    });
    html += '</div>' + paginationControlsHtml('companiesPage', cPage);
  }
  return html;
}
function renderBranding(){
  // Dvě položky Nastavení: "Firmy" (view 'companies', všechny právní
  // subjekty) a "Pracoviště a osoby" (view 'branding', aktivní firma).
  var html;
  if(state.view==='companies'){
    var ec = state.editCompanyId && state.companies.get(state.editCompanyId);
    html = ec
      ? settingsHeadHtml(ec.name||'Firma', 'Údaje firmy a kdo ji vidí.', null, 'App.cancelEditCompany()')
      : settingsHeadHtml('Firmy', 'Právní subjekty, pro které se audituje.');
    html += companiesSectionHtml();
  } else {
    var tab = (state.brandingTab && state.brandingTab!=='companies') ? state.brandingTab : 'workplaces';
    var co = currentCompany();
    html = settingsHeadHtml('Pracoviště a osoby', co ? ('Firma '+co.name+' — jinou vyberete v horním panelu.') : 'Provozovny a pracoviště aktivní firmy.');
    html += settingsTabsHtml([['workplaces','Pracoviště'],['branches','Provozovny']], tab, 'App.setBrandingTab');
    if(tab==='branches'){
      html += '<p class="set-note">Pracoviště bez provozovny se chápe jako na sídle firmy.</p>';
      html += branchesSectionHtml();
    } else {
      html += workplacesSectionHtml();
    }
  }
  document.getElementById('content').innerHTML = '<div class="content-narrow">' + html + '</div>';
}
App.setBrandingTab = function(tab){
  state.brandingTab = tab;
  state.editCompanyId = null; state.confirmTarget = '';
  render();
};
App.editCompany = function(id){
  state.editCompanyId = id;
  state.confirmTarget = '';
  render();
};
App.cancelEditCompany = function(){
  state.editCompanyId = null;
  render();
};

// Vyhledávání v Pracoviště a osoby (záložky wp / br) — text se drží
// v state.placeSearch, smaže se při přepnutí firmy.
function placeSearchQuery(kind){
  return normalizeSearchText(((state.placeSearch||{})[kind]||'').trim());
}
function placeSearchHtml(kind, placeholder, found, total){
  var q = (state.placeSearch||{})[kind] || '';
  return '<div class="field" style="margin:12px 0 0"><input id="placeSearch_'+kind+'" value="'+esc(q)+'" placeholder="'+esc(placeholder)+'" aria-label="Hledat" oninput="App.setPlaceSearch(\''+kind+'\', this.value)"/></div>' +
    (q.trim() ? '<div class="muted" style="font-size:var(--fs-sm);margin-top:6px">Nalezeno '+found+' z '+total+'</div>' : '');
}
function placeSearchMatches(q, parts){
  return normalizeSearchText(parts.filter(Boolean).join(' ')).indexOf(q)!==-1;
}
App.setPlaceSearch = function(kind, v){
  if(!state.placeSearch) state.placeSearch = {};
  state.placeSearch[kind] = v;
  render();
};

// ================= PROVOZOVNY =================
function branchesSectionHtml(){
  var html = '';
  var brs = sortedBranches();
  var brQ = placeSearchQuery('br');
  var brAll = brs;
  if(brQ) brs = brs.filter(function(e){ return placeSearchMatches(brQ, [e[1].name, e[1].address]); });
  if(brAll.length) html += placeSearchHtml('br', 'Hledat podle názvu nebo adresy…', brs.length, brAll.length);
  if(brAll.length===0){
    html += '<div class="empty">'+ICONS.empty+'<p>Žádná provozovna zatím není založena. Pracoviště se pak chápou jako na sídle firmy.</p></div>';
  } else if(brs.length===0){
    html += '<div class="card" style="margin-top:12px"><div class="muted" style="font-size:var(--fs-base)">Hledání neodpovídá žádná provozovna.</div></div>';
  } else {
    var brPage = paginateList(brs, 'branchesPage', 'branchesPageSig', brQ);
    html += '<div class="card" style="margin-top:12px">';
    brPage.items.forEach(function(e){
      var id=e[0], b=e[1];
      var wpCount = sortedWorkplaces().filter(function(we){ return we[1].branchId===id; }).length;
      html += '<div class="list-item"><div style="min-width:0"><div style="font-weight:600;font-size:var(--fs-md)">'+esc(b.name)+'</div>' +
        '<div class="muted" style="font-size:var(--fs-sm);margin-top:2px">'+[esc(b.address||''), wpCount+' prac.'].filter(Boolean).join(' · ')+'</div></div></div>';
    });
    html += '</div>' + paginationControlsHtml('branchesPage', brPage);
  }
  return html;
}

// ================= PRACOVIŠTĚ =================
function workplacesSectionHtml(){
  var html = '';
  var wps = sortedWorkplaces();
  var wpQ = placeSearchQuery('wp');
  var wpGroups = groupWorkplacesByBranch();
  var wpFound = wps.length;
  if(wpQ){
    // Hledá v názvu, poznámce, provozovně a odpovědné osobě; skupiny bez
    // výsledku se skryjí, ostatní se ukážou rozbalené.
    wpFound = 0;
    wpGroups = wpGroups.map(function(grp){
      var items = grp.items.filter(function(e){
        var rpId = responsiblePersonForWorkplace(e[0]);
        return placeSearchMatches(wpQ, [workplaceLabel(e[1]), e[1].note, grp.label, rpId ? userNameById(rpId) : '']);
      });
      wpFound += items.length;
      return {branchId:grp.branchId, label:grp.label, items:items};
    }).filter(function(grp){ return grp.items.length>0; });
  }
  if(wps.length) html += '<button class="btn btn-block" style="margin-top:8px" onclick="App.openQrPrint()">'+ICONS.qr+' Tisk QR štítků pracovišť</button>' +
    '<div class="set-note" style="margin:6px 0 10px">QR kód na pracovišti otevře po načtení telefonem stránku pracoviště se zahájením auditu. Doporučené štítky: Avery Zweckform L7121-25 (45 × 45 mm).</div>';
  if(wps.length) html += placeSearchHtml('wp', 'Hledat pracoviště, provozovnu, osobu…', wpFound, wps.length);
  if(wps.length===0){
    html += '<div class="empty">'+ICONS.empty+'<p>Žádná pracoviště zatím nejsou založena.</p></div>';
  } else if(wpGroups.length===0){
    html += '<div class="card" style="margin-top:12px"><div class="muted" style="font-size:var(--fs-base)">Hledání neodpovídá žádné pracoviště.</div></div>';
  } else {
    wpGroups.forEach(function(grp){
      var collapsed = !wpQ && state.collapsedWpBranches.has(grp.branchId);
      html += '<div class="group-section" style="margin-top:12px">';
      html += '<div class="group-head" onclick="App.toggleWpBranchGroup(\''+grp.branchId+'\')">' +
        '<div class="title"><span style="transform:rotate('+(collapsed?0:90)+'deg);display:inline-flex;transition:.15s">'+ICONS.chev+'</span>'+esc(grp.label)+'</div>' +
        '<div class="count">'+grp.items.length+' prac.</div></div>';
      if(!collapsed){
        // Stránkování zvlášť v každé provozovně (nadpis skupiny zůstává).
        var wpPageKey = 'wpPage_'+(grp.branchId||'hq').replace(/[^A-Za-z0-9_-]/g,'');
        var visItems = wpQ ? grp.items : grp.items.filter(function(e){ return !(e[1].parentId && state.collapsedWpChildren.has(e[1].parentId)); });
        var wpPage = paginateList(visItems, wpPageKey, wpPageKey+'Sig', wpQ);
        html += '<div class="group-body">';
        wpPage.items.forEach(function(e){
          var id=e[0], w=e[1];
          var rpId = responsiblePersonForWorkplace(id);
          var parent = workplaceParent(w);
          var kids = parent ? 0 : workplaceChildren(id).length;
          var sub = [esc(w.note||''), rpId ? 'Odpovídá: '+esc(userNameById(rpId)||'Neznámý uživatel') : '', kids ? 'podřízená: '+kids : ''].filter(Boolean).join(' · ');
          html += '<div class="list-item'+(parent?' wp-child':'')+'" onclick="event.stopPropagation()">' +
            '<div style="min-width:0"><div style="font-weight:600;font-size:var(--fs-md)">'+(parent?'<span class="muted" aria-hidden="true">↳ </span>':'')+esc(w.name)+'</div>' +
            (sub ? '<div class="muted" style="font-size:var(--fs-sm);margin-top:2px">'+sub+'</div>' : '') + '</div>' +
            '<div style="display:flex;gap:2px;flex-shrink:0;align-items:center">' +
            (kids ? (function(){ var hid = !wpQ && state.collapsedWpChildren.has(id);
              return '<button class="btn btn-sm btn-ghost" data-toggle-kids="'+id+'" aria-expanded="'+(!hid)+'" title="'+(hid?'Ukázat':'Schovat')+' podřízená pracoviště" onclick="App.toggleWpChildren(\''+id+'\')">'+(hid?'▸':'▾')+' '+kids+'</button>'; })() : '') +
            '<button class="icon-btn" title="QR kód" onclick="App.openQrPrint(\''+id+'\')">'+ICONS.qr+'</button></div></div>';
        });
        html += paginationControlsHtml(wpPageKey, wpPage) + '</div>';
      }
      html += '</div>';
    });
  }
  return html;
}
App.toggleWpChildren = function(id){
  if(state.collapsedWpChildren.has(id)) state.collapsedWpChildren.delete(id);
  else state.collapsedWpChildren.add(id);
  render();
};
App.toggleWpBranchGroup = function(branchId){
  if(state.collapsedWpBranches.has(branchId)) state.collapsedWpBranches.delete(branchId);
  else state.collapsedWpBranches.add(branchId);
  render();
};

// ================= ODPOVĚDNÉ OSOBY = UŽIVATELÉ (rozhodnutí uživatele 2026-10-31) =================
// Odpovědná osoba za pracoviště i za opatření je vždy registrovaný uživatel
// s přístupem k firmě. Pracoviště: workplaces.data.responsibleUserId (jedna
// osoba). Opatření: correctiveAction.responsibleId (+ responsible = jméno pro
// zobrazení a starší data). Dřívější tabulka responsible_persons se nepoužívá.
function userNameById(id){
  if(!id) return '';
  var p = state.profiles.get(id) || {};
  var full = ((p.firstName||'')+' '+(p.lastName||'')).trim();
  var dn = (p.displayName||'').indexOf('@')<0 ? (p.displayName||'') : '';
  return dn || full || (state.roleProfiles && state.roleProfiles[id] && state.roleProfiles[id].name) || p.email || '';
}
// Uživatelé s přístupem k aktivní firmě [[id, jméno]], abecedně.
function responsibleUserCandidates(){
  return usersWithCompanyAccess([state.currentCompanyId||'']).map(function(e){ return [e[0], userNameById(e[0]) || e[1]]; })
    .sort(function(a,b){ return a[1].localeCompare(b[1],'cs'); });
}
// opts.external = true → na konci volba „Jiná osoba (bez účtu)…“ (jen opatření,
// rozhodnutí uživatele 2026-11-03); opts.externalSelected = je vybraná.
var EXTERNAL_RESPONSIBLE = '__ext__';
function responsibleUserOptionsHtml(selectedId, emptyLabel, opts){
  opts = opts || {};
  var ext = !!opts.externalSelected;
  var list = responsibleUserCandidates();
  if(selectedId && !ext && !list.some(function(e){ return e[0]===selectedId; })) list.push([selectedId, userNameById(selectedId) || 'Neznámý uživatel']);
  return '<option value=""'+(!selectedId && !ext?' selected':'')+'>'+esc(emptyLabel||'– vyberte –')+'</option>' +
    list.map(function(e){ return '<option value="'+e[0]+'"'+(!ext && selectedId===e[0]?' selected':'')+'>'+esc(e[1])+'</option>'; }).join('') +
    (opts.external ? '<option value="'+EXTERNAL_RESPONSIBLE+'"'+(ext?' selected':'')+'>Jiná osoba (bez účtu)…</option>' : '');
}
// Jméno a příjmení osoby bez účtu (dvě povinná pole) — onInput(part, value) bez render().
function externalResponsibleFieldsHtml(first, last, onInputPrefix, onBlur, idPrefix){
  return '<div class="field-row ext-resp">' +
    '<div class="field" style="flex:1"><label for="'+idPrefix+'First">Jméno</label><input id="'+idPrefix+'First" type="text" autocomplete="off" value="'+esc(first||'')+'" ' +
      'oninput="'+onInputPrefix+'\'first\',this.value)"'+(onBlur?' onblur="'+onBlur+'"':'')+'/></div>' +
    '<div class="field" style="flex:1"><label for="'+idPrefix+'Last">Příjmení</label><input id="'+idPrefix+'Last" type="text" autocomplete="off" value="'+esc(last||'')+'" ' +
      'oninput="'+onInputPrefix+'\'last\',this.value)"'+(onBlur?' onblur="'+onBlur+'"':'')+'/></div>' +
    '</div>';
}
// Jméno osoby bez účtu se štítkem (karta, seznam opatření).
function responsibleLabelHtml(name, external){
  return esc(name) + (external ? ' <span class="badge badge-neutral">bez účtu</span>' : '');
}
// Odpovědná osoba pracoviště (id uživatele) nebo ''.
function responsiblePersonForWorkplace(workplaceId){
  var w = workplaceId && state.workplaces.get(workplaceId);
  return workplaceResponsibleId(w, function(id){ return state.workplaces.get(id); });
}
// Opatření přidělené mně: podle účtu; starší opatření bez účtu podle jména.
function isCorrectiveAssignedToMe(item){
  if(!item || !state.myId) return false;
  if(item.responsibleId) return item.responsibleId===state.myId;
  // Ručně zapsaná osoba bez účtu se nikdy nepřiřadí uživateli podle shody jména.
  if(item.responsibleExternal) return false;
  var name = (item.responsible||'').trim().toLowerCase();
  var me = userNameById(state.myId).trim().toLowerCase();
  return !!name && !!me && name===me;
}
function canChangeCorrectiveStatus(item){
  var r = myRole();
  if(r==='administrator' || r==='spravce') return true;
  // Odpovědná osoba bez účtu se nepřihlásí → stav mění i auditor, který opatření založil.
  if(item && item.responsibleExternal && item.auditorId && item.auditorId===state.myId) return true;
  return isMyCorrective(item); // Uživatel: svá opatření + opatření na mých pracovištích
}

export {
  EXTERNAL_RESPONSIBLE,
  externalResponsibleFieldsHtml,
  responsibleLabelHtml,
  canChangeCorrectiveStatus,
  portalPlacesUrl,
  isCorrectiveAssignedToMe,
  renderBranding,
  responsibleUserCandidates,
  responsibleUserOptionsHtml,
  responsiblePersonForWorkplace,
  userNameById
};
